/* istanbul ignore file */
import { AWSCredentials } from '@amzn/event-engine-js-utils';

import {
    EEContentCatalogClient,
    EEEventsClient,
    UnauthenticatedAWSClient,
} from './clients';

type TypeName =
    | 'EEEventsClient'
    | 'EEContentCatalogClient'
    | 'AWSClient'
    | 'UnauthenticatedAWSClient';

type ClientType<T> = T extends 'UnauthenticatedAWSClient'
    ? UnauthenticatedAWSClient
    : T extends 'EEContentCatalogClient'
    ? EEContentCatalogClient
    : T extends 'EEEventsClient'
    ? EEEventsClient
    : never;

class EventEngineClientFactory {
    private credentials = new AWSCredentials();

    constructor() {}

    public getClientSingleton = <T extends TypeName>(
        type: T
    ): ClientType<T> => {
        if (type === 'UnauthenticatedAWSClient') {
            return UnauthenticatedAWSClient.getInstance() as ClientType<UnauthenticatedAWSClient>;
        } else if (type === 'EEContentCatalogClient') {
            return EEContentCatalogClient.getInstance(
                this.credentials
            ) as ClientType<EEContentCatalogClient>;
        } else if (type === 'EEEventsClient') {
            return EEEventsClient.getInstance(
                this.credentials
            ) as ClientType<EEEventsClient>;
        }

        return undefined as ClientType<undefined>;
    };
}

export default new EventEngineClientFactory();
